import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=74742f52&scoped=true&"
import script from "./ViewItem.vue?vue&type=script&lang=ts&"
export * from "./ViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./ViewItem.vue?vue&type=style&index=0&id=74742f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74742f52",
  null
  
)

export default component.exports